import { deserializeProject } from '@rawgraphs/rawgraphs-core'

const LUGSAIL_PROJECT_FORMAT = 'lugsail-project'

function matrixToObjects(matrix, columns) {
  return (matrix || []).map((record) => {
    const obj = {}
    for (let i = 0; i < columns.length; i += 1) {
      obj[columns[i]] = record[i]
    }
    return obj
  })
}

function normalizeSerializedProject(projectPayload, charts) {
  if (!projectPayload || typeof projectPayload !== 'object') {
    return projectPayload
  }

  if (projectPayload.currentChart) {
    return projectPayload
  }

  const chartId =
    typeof projectPayload.chart === 'string'
      ? projectPayload.chart
      : projectPayload.chart?.metadata?.id ||
        projectPayload.chart?.metadata?.name ||
        null

  if (!chartId) {
    return projectPayload
  }

  const chart = charts.find(
    (candidate) =>
      candidate?.metadata?.id === chartId ||
      candidate?.metadata?.name === chartId
  )

  if (!chart) {
    throw new Error('Unknown chart!')
  }

  return {
    userInput: projectPayload.userInput,
    userData: matrixToObjects(
      projectPayload.rawData,
      Object.keys(projectPayload.dataTypes || {})
    ),
    userDataType: projectPayload.userInputFormat,
    parseError: projectPayload.parseError,
    unstackedData: projectPayload.parseOptions?.unstackedData,
    unstackedColumns: projectPayload.parseOptions?.unstackedColumns,
    dataTypes: projectPayload.dataTypes,
    separator: projectPayload.parseOptions?.separator,
    thousandsSeparator: projectPayload.parseOptions?.thousandsSeparator,
    decimalsSeparator: projectPayload.parseOptions?.decimalsSeparator,
    locale: projectPayload.parseOptions?.locale,
    stackDimension: projectPayload.parseOptions?.stackDimension,
    dataSource: projectPayload.dataSource,
    currentChart: chart,
    mapping: projectPayload.mapping,
    visualOptions: projectPayload.visualOptions,
  }
}

export function serializeLugsailProject({
  project,
  brandTheme,
  chartColorSyncMode,
}) {
  return JSON.stringify({
    format: LUGSAIL_PROJECT_FORMAT,
    version: 1,
    project,
    brandTheme,
    chartColorSyncMode,
  })
}

export function deserializeLugsailProject(payload, charts) {
  if (typeof payload !== 'string') {
    return {
      project: normalizeSerializedProject(payload, charts),
      brandTheme: null,
      chartColorSyncMode: null,
      isLugsailEnvelope: false,
    }
  }

  try {
    const parsed = JSON.parse(payload)
    if (parsed?.format === LUGSAIL_PROJECT_FORMAT && parsed?.project) {
      const project =
        typeof parsed.project === 'string'
          ? deserializeProject(parsed.project, charts)
          : normalizeSerializedProject(parsed.project, charts)

      return {
        project,
        brandTheme: parsed.brandTheme || null,
        chartColorSyncMode: parsed.chartColorSyncMode || null,
        isLugsailEnvelope: true,
      }
    }
  } catch (error) {
    // fall through to legacy project payload parsing
  }

  return {
    project:
      typeof payload === 'string'
        ? deserializeProject(payload, charts)
        : normalizeSerializedProject(payload, charts),
    brandTheme: null,
    chartColorSyncMode: null,
    isLugsailEnvelope: false,
  }
}
